export const Marquee = ({ items }) => {
  const row = [...items, ...items];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-[#0e1420]/10 bg-[var(--ivory)] py-8 text-[var(--ink)]">
      <div className="marquee-track flex w-max">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
            {row.map((w, i) => (
              <span key={`${k}-${i}`} className="flex items-center font-display text-4xl font-light tracking-tight md:text-6xl">
                <span className={i % 2 ? "italic text-[var(--gold-deep)]" : ""}>{w}</span>
                <span className="mx-10 inline-block h-3 w-3 rotate-45 border border-[var(--gold-deep)]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
